var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgCalendar = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M14.688 3.143H3.313a.5.5 0 0 0-.5.5v11.375a.5.5 0 0 0 .5.5h11.375a.5.5 0 0 0 .5-.5V3.643a.5.5 0 0 0-.5-.5ZM3 6.518h12M5.438 1.83v3m7.125-3v3" }), _jsx("path", { fill: "currentColor", d: "M6.75 8.576h-1.5v1.5h1.5zm3 0h-1.5v1.5h1.5zm3 0h-1.5v1.5h1.5zm-6 3h-1.5v1.5h1.5zm3 0h-1.5v1.5h1.5zm3 0h-1.5v1.5h1.5z" })] }))); };
export default SvgCalendar;
